import type { SxProps, Theme } from '@mui/material';

export const containerSx: SxProps<Theme> = {
  p: 2,
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const menuPaperSx: SxProps<Theme> = {
  maxHeight: 200,
  maxWidth: '286px',
  overflowX: 'hidden',
};

export const menuItemContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const menuItemTextSx: SxProps<Theme> = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  width: '210px',
};

export const readonlyContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0.5,
};
